import React, { Component } from "react";

import PropTypes from "prop-types";

import "ol/ol.css";

import BoundsGeoJson from "../geo/bounds.json";
import RouteGeoJson from "../geo/route.json";
import VenueGeoJson from "../geo/venue.json";

import FlagBlue from "../images/flag-blue.png";
import StarOrange from "../images/star-icon.png";

const MAPBOX_TOKEN = process.env.GATSBY_MAPBOX_TOKEN;
const MAPBOX_TILE_ID = "amahon/cjztah69n0rnk1cog10un19s1";
const MAPBOX_TILE_URL =
  "https://api.mapbox.com/styles/v1/" +
  MAPBOX_TILE_ID +
  "/tiles/256/{z}/{x}/{y}?access_token=" +
  MAPBOX_TOKEN;

class WeddingMap extends Component {
  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount(props) {
    const Circle = require("ol/style").Circle;
    const DragPan = require("ol/interaction").DragPan;
    const Feature = require("ol/Feature").default;
    const Fill = require("ol/style").Fill;
    const GeoJSON = require("ol/format/GeoJSON").default;
    this.GeoJSON = GeoJSON;
    const Icon = require("ol/style/Icon").default;
    const LayerTile = require("ol/layer/Tile").default;
    const LayerVector = require("ol/layer/Vector").default;
    const Map = require("ol/Map").default;
    const PinchZoom = require("ol/interaction").PinchZoom;
    const Point = require("ol/geom/Point").default;
    const Projection = require("ol/proj/Projection").default;
    const SourceOSM = require("ol/source/OSM").default;
    const SourceVector = require("ol/source/Vector").default;
    const Stroke = require("ol/style").Stroke;
    const CircleStyle = require("ol/style").CircleStyle;
    const Style = require("ol/style").Style;
    const View = require("ol/View").default;
    const defaultControls = require("ol/control").defaults;
    const defaultInteractions = require("ol/interaction").defaults;
    const fromLonLat = require("ol/proj").fromLonLat;
    const projectionGet = require("ol/proj").get;
    this.projectionGet = projectionGet;
    const transformExtent = require("ol/proj").transformExtent;

    // Styles

    this.routeStyle = new Style({
      stroke: new Stroke({
        color: [255, 178, 91, 0.75],
        width: 3,
        opacity: 0.75
      })
    });
    this.venueStyle = new Style({
      image: new Icon({
        src: StarOrange,
        anchorOrigin: "bottom-left",
        anchor: [0.5, 0]
      })
    });
    this.poiStyle = new Style({
      image: new Icon({
        src: FlagBlue,
        offsetOrigin: "bottom-left",
        anchorOrigin: "bottom-left",
        anchor: [0, 0]
      })
    });

    this.routeFeatures = new GeoJSON().readFeatures(RouteGeoJson, {
      dataProjection: projectionGet("EPSG:4326"),
      featureProjection: projectionGet("EPSG:3857")
    });
    this.routeSource = new SourceVector({
      features: this.routeFeatures
    });
    this.routeLayer = new LayerVector({
      source: this.routeSource,
      style: this.routeStyle
    });

    this.venueFeature = new GeoJSON().readFeatures(VenueGeoJson, {
      dataProjection: projectionGet("EPSG:4326"),
      featureProjection: projectionGet("EPSG:3857")
    });
    this.venueSource = new SourceVector({
      features: this.venueFeature
    });
    this.venueLayer = new LayerVector({
      source: this.venueSource,
      style: this.venueStyle
    });

    this.poiFeatures = [];
    this.props.pois.forEach(poi => {
      let _feature = new GeoJSON().readFeature(poi.location, {
        dataProjection: projectionGet("EPSG:4326"),
        featureProjection: projectionGet("EPSG:3857")
      });
      _feature.setProperties({
        name: poi.name
      });
      this.poiFeatures.push(_feature);
    });
    this.poiSource = new SourceVector({
      features: this.poiFeatures
    });
    this.poiLayer = new LayerVector({
      source: this.poiSource,
      style: this.poiStyle
    });

    this.controls = defaultControls({
      zoom: false
    });

    this.interactions = defaultInteractions({
      altShiftDragRotate: false,
      doubleClickZoom: false,
      dragAndDrop: false,
      dragPan: true,
      keyboard: false,
      mouseWheelZoom: false,
      pinchRotate: false,
      pinchZoom: true,
      pointer: false,
      select: false,
      shiftDragZoom: true
    });

    let dragPan = new DragPan();
    let pinchZoom = new PinchZoom();

    this.baseLayer = new LayerTile({
      source: new SourceOSM({
        url: MAPBOX_TILE_URL
      })
    });

    this.view = new View({
      center: this.props.center,
      zoom: this.props.zoom
    });

    this.olmap = new Map({
      controls: this.controls,
      target: this.props.mapid,
      layers: [this.baseLayer, this.routeLayer, this.venueLayer, this.poiLayer],
      view: this.view,
      interactions: this.interactions
    });

    //this.olmap.addInteraction(dragPan);
    //dragPan.setActive(false);

    // let _map = this.olmap;
    // let pointers = 0;
    // this.olmap.on('pointerdown', function() {
    //   pointers++;
    //   if(pointers >= 2) {
    //     _map.addInteraction(dragPan);
    //     _map.addInteraction(pinchZoom);
    //   }
    // });
    // this.olmap.on('pointerup', function() {
    //   pointers--;
    //   if(pointers < 2){
    //     _map.removeInteraction(dragPan);
    //     _map.removeInteraction(pinchZoom);
    //   }
    // });

    this.view.fit(this.props.bounds.getGeometry(), this.olmap.getSize(), {
      padding: [0, 0, 0, 0]
    });

    window.addEventListener("resize", this.handleResize);
  }

  handleResize(e) {
    // this.view.fit(this.props.bounds.getGeometry(), this.olmap.getSize(), {
    //   padding: [0, 0, 0, 0]
    // });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.currentThing != prevProps.currentThing) {
      this.highlightCurrentThing();
    }
    if (this.props.bounds != prevProps.bounds) {
      this.panToCurrentThing();
    }
  }

  highlightCurrentThing() {
    const easeOut = require("ol/easing").easeOut;
    const Stroke = require("ol/style").Stroke;
    const CircleStyle = require("ol/style").Circle;
    const Style = require("ol/style").Style;
    const unByKey = require("ol/Observable").unByKey;

    let _feature = new this.GeoJSON().readFeature(
      this.props.currentThing.location,
      {
        dataProjection: this.projectionGet("EPSG:4326"),
        featureProjection: this.projectionGet("EPSG:3857")
      }
    );

    var duration = 1000;
    var start = new Date().getTime();
    var listenerKey = this.olmap.on("postcompose", animate);
    var map = this.olmap;
    this.olmap.render();

    function animate(event) {
      var vectorContext = event.vectorContext;
      var frameState = event.frameState;
      var flashGeom = _feature.getGeometry().clone();
      var elapsed = frameState.time - start;
      var elapsedRatio = elapsed / duration;
      // radius will be 5 at start and 30 at end.
      var radius = easeOut(elapsedRatio) * 25 + 5;
      var opacity = easeOut(1 - elapsedRatio);

      var style = new Style({
        image: new CircleStyle({
          radius: radius,
          stroke: new Stroke({
            color: "rgba(255, 255, 255, " + opacity + ")",
            width: opacity * 5
          })
        })
      });

      vectorContext.setStyle(style);
      vectorContext.drawGeometry(flashGeom);
      if (elapsed > duration) {
        unByKey(listenerKey);
        return;
      }
      map.render();
    }
  }

  panToCurrentThing() {
    this.view.cancelAnimations();
    this.view.fit(this.props.bounds.getGeometry(), {
      padding: [0, 0, 0, 0],
      duration: 1000
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    return (
      <div className="ol-map-container">
        <div className="ol-map" id={this.props.mapid} />
      </div>
    );
  }
}

WeddingMap.propTypes = {
  mapid: PropTypes.string.isRequired,
  pois: PropTypes.array.isRequired,
  bounds: PropTypes.object
};

export default WeddingMap;
